var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 15V10.9003C17.3578 10.7174 17.6929 10.4965 18 10.2428V15C18 16.3807 16.8807 17.5 15.5 17.5H4.5C3.11929 17.5 2 16.3807 2 15V7C2 5.61929 3.11929 4.5 4.5 4.5H9.20703C9.11588 4.82228 9.05337 5.15659 9.02242 5.5H4.5C3.67157 5.5 3 6.17157 3 7V7.302L10 11.4199L11.4414 10.5718C11.766 10.7894 12.1151 10.9733 12.4836 11.1186L10.2535 12.431C10.1231 12.5077 9.96661 12.5205 9.82751 12.4693L9.74649 12.431L3 8.463V15C3 15.8284 3.67157 16.5 4.5 16.5H15.5C16.3284 16.5 17 15.8284 17 15ZM14.5 10.5C16.9853 10.5 19 8.48528 19 6C19 3.51472 16.9853 1.5 14.5 1.5C12.0147 1.5 10 3.51472 10 6C10 8.48528 12.0147 10.5 14.5 10.5ZM16.8536 4.85355L13.8536 7.85355C13.6583 8.04882 13.3417 8.04882 13.1464 7.85355L12.1464 6.85355C11.9512 6.65829 11.9512 6.34171 12.1464 6.14645C12.3417 5.95118 12.6583 5.95118 12.8536 6.14645L13.5 6.79289L16.1464 4.14645C16.3417 3.95118 16.6583 3.95118 16.8536 4.14645C17.0488 4.34171 17.0488 4.65829 16.8536 4.85355Z",
    fill: "#323130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.18a94feabbc1d3c9f19c1d3efc689470.svg";
export { ForwardRef as ReactComponent };